import type { ProcessTemplateListItemType } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import ProcessDirTableRow from './ProcessDirTableRow';

interface ProcessDirTableBodyProps {
    templates: ProcessTemplateListItemType[];
    colSpan: number;
    onSelect?: (template: ProcessTemplateListItemType) => void;
    onEdit?: (template: ProcessTemplateListItemType) => void;
    onDelete?: (template: ProcessTemplateListItemType) => void;
}

const ProcessDirTableBody = ({ templates, colSpan, onSelect, onEdit, onDelete }: ProcessDirTableBodyProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <tbody>
            {!templates.length ? (
                <TableEmptyRow colSpan={colSpan} className="text-muted text-center py-4">
                    {t('processDir.empty')}
                </TableEmptyRow>
            ) : (
                templates.map((template) => (
                    <ProcessDirTableRow
                        key={template.ID}
                        template={template}
                        onSelect={onSelect}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                ))
            )}
        </tbody>
    );
};

export default ProcessDirTableBody;
